import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'

const SearchBar = (props) => {
  const [search, setSearch] = useState('')

  const handleChange = (e) => setSearch(e.target.value)

  const handleSearchSubmit = (e) => {
    e.preventDefault()
    props.updateFilter({ search })
  }

  const handleSearchReset = (e) => {
    const search = ''
    setSearch(search)
    props.updateFilter({ search })
  }

  const handleEnterKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearchSubmit(e)
    }
  }

  useEffect(() => {
    setSearch(props.filter)
  }, [props.filter])

  return (
    <div style={{ minHeight: '48px' }}>
      <div className={'input-group'}>
        <input
          onKeyPress={handleEnterKeyPress}
          name='search-field'
          className='form-control'
          placeholder='Search'
          value={search}
          onChange={handleChange}
        />
        <button name='search-btn' className='btn btn-default' type='button' onClick={handleSearchSubmit}>
          Search
        </button>
        <button name='reset-btn' className='btn btn-default' type='button' onClick={handleSearchReset}>
          Reset
        </button>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({})

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SearchBar))
